import { Component, ViewEncapsulation, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { LocaleService } from 'app/components/locale/locale.service';
import { vehicle } from '../../../locale/locale';

import { PFObject } from 'app/components/data/core/models/base/object';

import { CurrentUser } from 'app/components/data/core/models/base/user';
import { Vehicle } from 'app/components/data/core/models/transport/transport';

import * as CustomValidators from 'app/components/validators/validators';
import * as FormHelper from 'app/components/form-helper/form-helper';
import { DataLoader } from 'app/components/data/data-loader';
import { CloudExecutor } from 'app/components/data/cloud-executors/cloud-executor';

@Component({
    selector   : 'vehicle-approve-dialog',
    templateUrl: './vehicle-approve-dialog.component.html',
    styleUrls  : ['./vehicle-approve-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class VehicleApproveDialog {
  compareFunction = PFObject.compareFn;
  
  public form: UntypedFormGroup;
  private object: Vehicle;

  public _buttonName: string;

  public modelsLoader: DataLoader;
  public dataSaver = new CloudExecutor;

  constructor (
    private localeService: LocaleService,
    public dialogRef: MatDialogRef<VehicleApproveDialog>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _formBuilder: UntypedFormBuilder
  ) {
    this.modelsLoader = new DataLoader('VehicleModel');

    this.localeService.loadLocale(vehicle);
    this.object = this._data.object;
    this.form = this.createContactForm();
  }

  createContactForm(): UntypedFormGroup
  {
    let number = this.object.number();
    let tonnageValidators = [Validators.min(1), Validators.max(99)];

    return this._formBuilder.group({
                model: [{value: this.object.model().name(), disabled: true}],
                number: [{value: number, disabled: true}],
                tonnage: [{value: this.object.tonnage(), disabled: true}, tonnageValidators],
                carrier: [{value: this.object.carrier(), disabled: true}],
              });
  }

  ngOnInit() {
    this.loadData();
  }

  isCarrierVisible(): boolean {
    return CurrentUser.isAdministrator() || CurrentUser.isLogistician();
  }

  loadData() {
    this.modelsLoader.loadAll();
  }

  isApproved(): boolean {
    return this.object.approved();
  }

  toggleApprovement() {
    this.approve(!this.object.approved());
  }

  approve(value: boolean) {
    this.object.setApproved(value);
    this.dataSaver.saveObject(this.object).then((obj) => {
      this.close(obj);
    });
  }

  close(obj) {
    this.dialogRef.close(obj);
  }

  checkForm() : boolean {
    return FormHelper.checkForm(this.form);
  }
}
